import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
  appBar: {
    // position: 'relative'
    marginBottom: theme.spacing(3)
  },
  title: {
    flexGrow: 1
  }
}))
